import { Component, Input, OnInit } from '@angular/core';
import { LinksModule } from '@app/models/content';
import { ToolsService } from '@app/services/tools/tools.service';

@Component({
  selector: 'app-links-module',
  templateUrl: './links-module.component.html',
  styleUrls: ['./links-module.component.scss']
})
export class LinksModuleComponent implements OnInit {

  @Input() module: LinksModule;

  constructor(
    private toolsService: ToolsService
  ) { }

  ngOnInit() {
  }

  onAnchorClick(e) {
    e.preventDefault();
    this.toolsService.scrollIntoView(e.target.getAttribute('href'));
  }

}
